/* ==========================================================================
   Productos relacionados (sections/related-product.liquid). Vanilla JS; the
   cards' plugins use jQuery if it's there.
   - After the page loads, asks Shopify's recommendations (intent related)
     for the same section, which prints only the recommended cards.
   - Shows them first and fills up to the limit (data-limit) with the
     fallback cards of the section's <template> (the product's collection),
     never the product itself nor a card twice. No cards: stays hidden.
   - The cards are the collection page's (product-grid-item): sets up what
     the theme only prepares on page load (as activateCards() in
     home-page.js).
   - Carousel: native scroll with snap (CSS), arrows and dots with
     window.DotPager (theme.js.liquid), as the search page's shortcuts
     (shortcutPager in search-filters.js). Rebuilt when the width changes
     the number of views.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = '[data-related]';
  var CHEVRON_PREV = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_NEXT = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function create(tag, className) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    return el;
  }

  /* Cards ------------------------------------------------------------------ */

  // Hearts without the tooltip: on touch screens the "Lista de Deseados"
  // bubble stayed stuck after a tap. The title becomes the aria-label.
  // Copy of plainHearts() in assets/filter-bar.js and assets/home-page.js:
  // change the three together.
  function plainHearts(scope) {
    var $ = window.jQuery;
    scope.querySelectorAll('.cc-grid .button-group .wishlist[data-toggle="tooltip"]').forEach(function (heart) {
      if ($ && $.fn.tooltip) $(heart).tooltip('dispose');
      var label = heart.getAttribute('title') || heart.getAttribute('data-original-title');
      if (label) heart.setAttribute('aria-label', label);
      heart.removeAttribute('title');
      heart.removeAttribute('data-original-title');
      heart.removeAttribute('data-toggle');
    });
  }

  // What the theme only sets up on page load (as activateCards() in
  // home-page.js). Images: the theme's lazy loading plugin only watches the
  // window's scroll, not a horizontal carousel, so they go to the browser's
  // native lazy loading. That also gives the cart popup (Shopify.cartPopap,
  // which reads the card's .popup_cart_image) its photo.
  function activateCards(root) {
    var $ = window.jQuery;
    root.querySelectorAll('img.lazyload[data-src]').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('src', img.getAttribute('data-src'));
      img.classList.remove('lazyload');
    });
    plainHearts(root);
    // Quick view and compare tooltips (theme.js)
    if ($ && $.fn.tooltip) $(root).find('[data-toggle="tooltip"]').tooltip();
    // Hearts of products already in the wishlist (wishlist.js; clicks are delegated)
    if (window.Wishlist && window.Wishlist.activate) window.Wishlist.activate(root);
    // Color swatches swap the card image (theme.js)
    root.querySelectorAll('.product-color li label').forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var link = label.parentNode.querySelector('.hidden a');
        var card = label.closest('.product-wrapper');
        if (!link || !card) return;
        card.querySelectorAll('.popup_cart_image').forEach(function (img) {
          img.setAttribute('src', link.getAttribute('href'));
        });
      });
    });
  }

  /* Carousel --------------------------------------------------------------- */

  function carousel(root) {
    var box = root.querySelector('[data-related-carousel]');
    var track = box && box.querySelector('[data-pager-track]');
    if (!track || !window.DotPager) return;
    var pager = new window.DotPager(box);
    var dots = null;
    var arrows = null;
    var shown = -1;
    var ticking = false;

    function arrow(name, svg, label, step) {
      var button = create('button', 'rp-arrow rp-arrow--' + name);
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.innerHTML = svg;
      button.addEventListener('click', function () {
        var page = pager.current() + step;
        pager.goTo(Math.max(0, Math.min(page, pager.dots.length - 1)));
      });
      return button;
    }

    // Prev hidden at the start, next at the end
    function syncArrows() {
      if (!arrows) return;
      var max = track.scrollWidth - track.clientWidth;
      arrows[0].classList.toggle('is-off', track.scrollLeft <= 1);
      arrows[1].classList.toggle('is-off', track.scrollLeft >= max - 2);
    }

    // One dot per view; none when every card fits
    function build() {
      var max = track.scrollWidth - track.clientWidth;
      var count = max > 1 ? Math.max(Math.ceil(max / pager.pageWidth() - 0.15), 1) + 1 : 0;
      if (count === shown) return syncArrows();
      shown = count;
      if (dots) dots.remove();
      if (arrows) arrows.forEach(function (button) { button.remove(); });
      dots = null;
      arrows = null;
      if (count) {
        dots = create('div', 'rp-dots');
        for (var i = 1; i <= count; i++) {
          var dot = create('button', 'rp-dot');
          dot.type = 'button';
          dot.setAttribute('data-pager-dot', '');
          dot.setAttribute('aria-label', 'Ir a la página ' + i + ' de ' + count);
          dots.appendChild(dot);
        }
        box.appendChild(dots);
        arrows = [
          arrow('prev', CHEVRON_PREV, 'Productos anteriores', -1),
          arrow('next', CHEVRON_NEXT, 'Productos siguientes', 1)
        ];
        arrows.forEach(function (button) { track.parentNode.appendChild(button); });
      }
      pager.setDots(dots ? dots.children : []);
      syncArrows();
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncArrows();
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(build).observe(track);
    } else {
      window.addEventListener('resize', build);
    }
    build();
  }

  /* Setup ------------------------------------------------------------------ */

  function show(root, recommended) {
    var track = root.querySelector('[data-pager-track]');
    var template = root.querySelector('template[data-related-fallback]');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    var fallback = template ? Array.prototype.slice.call(template.content.querySelectorAll('.rp-cell')) : [];
    var seen = {};
    var count = 0;
    seen[root.getAttribute('data-product-id')] = true;

    recommended.concat(fallback).forEach(function (cell) {
      var id = cell.getAttribute('data-product-id');
      if (count >= limit || !id || seen[id]) return;
      seen[id] = true;
      count++;
      track.appendChild(document.importNode(cell, true));
    });
    if (!count) return;

    root.hidden = false;
    activateCards(track);
    carousel(root);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    Array.prototype.forEach.call(roots, function (root) {
      if (root.relatedReady) return;
      root.relatedReady = true;
      var url = root.getAttribute('data-url');
      if (!url || !window.fetch || !window.DOMParser) {
        show(root, []);
        return;
      }
      // Shopify answers with this section rendered for the recommendations
      fetch(url)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          show(root, Array.prototype.slice.call(doc.querySelectorAll('[data-related-items] .rp-cell')));
        })
        .catch(function () {
          show(root, []);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders the section: set up the new markup
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
